import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import { BlogCard } from "@/components/site/cards";
import { stagger, fadeUp, viewportOnce } from "@/lib/motion";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const categories = ["All", ...new Set(posts.map((p) => p.category))];
  const filtered = category === "All" ? posts : posts.filter((p) => p.category === category);

  return (
    <>
      <SEO title="Blog" description="Insights on performance, design, AI automation and growth from the Web Vantage Enterprises team." path="/blog" />
      <PageHero
        overline="Journal"
        title="Insights to help you win online"
        subtitle="Practical, no-fluff articles on performance, design, AI and growth from the people who build for a living."
        crumbs={[{ label: "Blog" }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv">
          <div className="mb-12 flex flex-wrap gap-3">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setCategory(c)}
                data-testid={`blog-filter-${c.toLowerCase()}`}
                className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                  category === c ? "bg-vantage text-white" : "border border-white/10 text-slate-400 hover:text-white"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <motion.div variants={stagger(0.08)} initial="hidden" whileInView="show" viewport={viewportOnce} className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {filtered.map((post) => (
              <motion.div key={post.id} variants={fadeUp}><BlogCard post={post} /></motion.div>
            ))}
          </motion.div>
          {filtered.length === 0 && <p className="text-center text-slate-500">No articles yet. Check back soon.</p>}
        </div>
      </section>
    </>
  );
}
